<template>
  <v-stepper v-if="currentStepName" class="pt-2" :alt-labels="$vuetify.breakpoint.mdAndUp" :value="currentStepOrder">
    <v-stepper-header class="pb-2">
      <template v-for="step in steps">
        <v-stepper-step :complete="currentStepOrder > step.order" :step="step.order">{{ step.title }}</v-stepper-step>
        <v-divider v-if="step.order !== lastStepOrder"></v-divider>
      </template>
    </v-stepper-header>
    <v-stepper-items>
      <v-stepper-content step="1">
        <div class="container">
          <h2 class="font font--reg-title text-center mb-sm-8 mb-5">Укажите контактные данные</h2>
          <ContactsForm />
        </div>
      </v-stepper-content>
      <v-stepper-content step="2">
        <div class="container">
          <template v-if="isNewCompany">
            <h2 class="font font--reg-title text-center mb-sm-8 mb-5">Укажите данные вашей компании</h2>
            <CreateCompanyForm v-on:set-new-company="newCompany = $event" v-on:go-back="isNewCompany = false" />
          </template>
          <template v-else>
            <h2 class="font font--reg-title text-center mb-sm-8 mb-5">Заполните основную информацию</h2>
            <MainInfoForm :newCompany="newCompany" v-on:create-company="isNewCompany = true" />
          </template>
        </div>
      </v-stepper-content>
      <v-stepper-content step="3">
        <div class="container">
          <h2 class="font font--reg-title text-center mb-sm-8 mb-5">Чуть больше о Вас</h2>
          <RegistrationSurvey />
        </div>
      </v-stepper-content>
      <v-stepper-content step="4">
        <div class="container">
          <h2 class="font font--reg-title text-center mb-sm-8 mb-5">Заполните данные для получения вознаграждения</h2>
          <BankDetailsForm />
        </div>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ContactsForm from "@/components/regstepper/ContactsForm.vue";
import MainInfoForm from "@/components/regstepper/MainInfoForm.vue";
import BankDetailsForm from "@/components/regstepper/BankDetailsForm.vue";
import CreateCompanyForm from "@/components/regstepper/CreateCompanyForm.vue";

const steps = {
  'person': {
    order: 1,
    title: 'Контакты',
  },
  'partner': {
    order: 2,
    title: 'Информация о партнёре',
  },
  'registration_survey': {
    order: 3,
    title: 'Анкета',
  },
  'requisites': {
    order: 4,
    title: 'Реквизиты',
  },
};

const lastStepOrder = Object.values(steps).sort((a, b) => b.order-a.order)[0].order;

export default {
  components: {
    ContactsForm,
    MainInfoForm,
    BankDetailsForm,
    CreateCompanyForm,

    RegistrationSurvey: () => import("@/components/regstepper/RegistrationSurvey.vue")
  },
  data() {
    return {
      isNewCompany: false,
      newCompany: null,
      steps
    };
  },

  computed: {
    ...mapGetters("profile", [
      "isFirstStepComplete",
      "isSecondStepComplete",
      "shouldShowCompanyDetailsForm",
      "reqIsNotFilled",
      "isRegistrationSurveyStepComplete"
    ]),

    lastStepOrder: () => lastStepOrder,

    currentStepName() {
      return [
        {
          completed: this.isFirstStepComplete,
          name: 'person',
        },
        {
          completed: this.isSecondStepComplete,
          name: 'partner',
        },
        {
          completed: this.isRegistrationSurveyStepComplete,
          name: 'registration_survey',
        },
        {
          completed: !this.reqIsNotFilled,
          name: 'requisites',
        },
      ].find(element => element.completed === false)?.name;
    },

    currentStepOrder() {
      if (!this.currentStepName) return null;

      return this.steps[this.currentStepName].order;
    },
  },
  mounted() {
    if (this.shouldShowCompanyDetailsForm) {
      this.isNewCompany = true
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 960px;
  background-color: #ffffff;
  border-radius: 4px;
  padding: 40px 184px 40px;

  @media screen and (min-width: 600px) and (max-width: 960px) {
    padding-left: 20px;
    padding-right: 20px;
  }

  @media screen and (max-width: 600px) {
    padding: 10px;
  }
}

@media screen and (max-width: 600px) {
  .v-stepper-content {
    padding: 0px 0px 16px 0px;
  }
}

$stepper-class: '.v-stepper';
#{$stepper-class}::v-deep {
  border-radius: 0;
  overflow: hidden;
  position: relative;
  box-shadow: none;
  background: transparent !important;

  #{$stepper-class}__header {
    max-width: 80%;
    width: auto;
    margin: 0 auto;
    box-shadow: none;


  }

  &#{$stepper-class}--alt-labels #{$stepper-class}__header .v-divider {
    margin: 39px -58px 0;
  }

  #{$stepper-class}__step__step {
    height: 32px;
    min-width: 32px;
    width: 32px;
    font-size: 1rem;
    font-weight: 500;
  }

  #{$stepper-class}__content {
    padding: 0;
  }

  #{$stepper-class}__label {
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    text-align: center!important;
    margin: 0 -10px;
  }

  #{$stepper-class}__step--complete #{$stepper-class}__label {
    color: #6CA300!important;
  }

  #{$stepper-class}__step--active #{$stepper-class}__label {
    color: #4971D0;
  }

  #{$stepper-class}__step--complete #{$stepper-class}__step__step {
    background-color: transparent!important;
    border-color: #88BD1F!important;
    border: 1.5px solid #88BD1F;

    .v-icon {
      color: #88BD1F;
    }
  }

  #{$stepper-class}__step--inactive #{$stepper-class}__step__step {
    background-color: transparent!important;
    border-color: #9DA6AA!important;
    border: 1.5px solid #9DA6AA;
    color: #9DA6AA;
  }

  #{$stepper-class}__step--active #{$stepper-class}__label {
    text-shadow: none;
  }
}
</style>
